import { createFileRoute } from "@tanstack/react-router";
import ChainsawGuide from "@/pages/ChainsawGuide";

const YEAR = new Date().getFullYear();
const PAGE_URL = "https://www.garden-review.co.uk/best-chainsaws-uk";

export const Route = createFileRoute("/best-chainsaws-uk")({
  head: () => {
    const title = `Best Chainsaws UK ${YEAR}: Tested & Compared`;
    const description = `Compare the best chainsaws for UK use in ${YEAR}, from pruning saws to felling machines, with live prices from top UK retailers.`;
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "article" },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
      ],
      links: [{ rel: "canonical", href: PAGE_URL }],
    };
  },
  component: ChainsawGuide,
});
